<script>
  import * as d3scale from 'd3-scale'
  import { getContext } from 'svelte'
  import {
    hoveredObjects,
    selectedStory,
    themes,
    selectedThemes,
    genres,
    selectedGenres,
    countries,
    selectedCountries,
  } from './stores.js'
  import PasswordProtect from './PasswordProtect.svelte'
  import Points from './Points.svelte'
  import ClusterSelection from './ClusterSelection.svelte'
  import AttributeFilter from './AttributeFilter.svelte'
  import StoryData from './StoryData.svelte'
  import * as Core from './core-components'
</script>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
    background: rgb(16, 28, 45);
    background: linear-gradient(
      135deg,
      rgba(16, 28, 45, 1) 0%,
      rgba(35, 44, 64, 1) 100%
    );
  }
  .cluster-selection {
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .filters-left {
    position: absolute;
    top: 80px;
    left: 5px;
    color: #ffffff;
    font-size: 1em;
  }
  .filters-right {
    position: absolute;
    top: 80px;
    right: 5px;
    color: #ffffff;
    font-size: 1em;
  }
  .filter {
    margin: 20px 0;
  }
  .story-data {
    position: absolute;
    top: 10px;
    left: 100px;
    right: 100px;
    color: #ffffff;
    font-size: 1em;
    text-align: center;
  }
</style>

<PasswordProtect>
  <Core.WebGL>

    <Core.OrbitControls maxPolarAngle={Math.PI * 0.5} target={[0, 0, 0]} />

    <Core.RayCaster
      on:objectsHover={e => {
        $hoveredObjects = e.detail
      }} />

    <Core.AmbientLight color={0xaaaaaa} />

    <Core.DirectionalLight
      color={0x555555}
      position={[0, 10, 0]}
      castShadow={false} />

    <Core.DirectionalLight
      color={0x333333}
      position={[0, 0, 10]}
      castShadow={false} />

    <Points
      sceneSize={5}
      pointSize={0.04}
      defaultColor={0x6600ff}
      selectionColor={0xffffff} />

  </Core.WebGL>

  <div class="cluster-selection">
    <ClusterSelection />
  </div>
  <div class="filters-left">
    <div class="filter">
      <AttributeFilter
        attributeName="genre"
        attributeValues={$genres}
        bind:selectedAttributeValues={$selectedGenres} />
    </div>
    <div class="filter">
      <AttributeFilter
        attributeName="theme"
        attributeValues={$themes}
        bind:selectedAttributeValues={$selectedThemes} />
    </div>
  </div>
  <div class="filters-right">

    <div class="filter">
      <AttributeFilter
        attributeName="country"
        attributeValues={$countries}
        bind:selectedAttributeValues={$selectedCountries} />
    </div>
  </div>
  {#if $selectedStory}
    <div class="story-data">
      <StoryData story={$selectedStory} />
    </div>
  {/if}

</PasswordProtect>
